import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import { isProofingSupportedForFile } from "csi/service/fileService";
import declare from "dojo/_base/declare";

export = declare(Action, {
	/**
	 * @override
	 * Only allow if file type of document is supported for proofing 
	 */
	hasAccess(ctx: Context) {
		const currentRevision = ctx.cache.getNode(ctx.getNode().CurrentRevision);
		return this.inherited(arguments) && isProofingSupportedForFile(currentRevision["File.File"]);
	},
});